'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PKE_ALGO_RSA = undefined;

var _nodeForge = require('node-forge');

var PKE_ALGO_RSA = exports.PKE_ALGO_RSA = { name: 'RSA', oid: _nodeForge.oids.rsaEncryption };